const SET_MESSAGE = 'SET_MESSAGE';
const REMOVE_MESSAGE = 'REMOVE_MESSAGE';

export { SET_MESSAGE, REMOVE_MESSAGE };
